import * as loader from 'shared/operators/loader';
import * as React from 'react';

import { IStateBase } from './BaseComponent';

interface IState extends IStateBase {
  refs: number[];
}

let timeout: any = null;

export default class LoaderComponent extends React.Component<{}, IState> {
  constructor(props: any) {
    super(props);

    loader.setup(this);
    this.state = { refs: [] };
  }

  public show(ref: number): void {
    if (typeof ref !== 'number') {
      throw new Error('Loader.show needs a ref number value');
    }

    const { refs } = this.state;
    if (refs.some(r => r === ref)) return;

    refs.push(ref);
    this.setState({ refs });
  }

  public hide(ref: number): void {
    if (typeof ref !== 'number') {
      throw new Error('Loader.hide needs a ref number value');
    }

    const { refs } = this.state;
    const index = refs.indexOf(ref);

    if (index === -1) {
      return;
    }

    refs.splice(index, 1);
    this.setState({ refs });
  }

  render(): any {
    const { refs } = this.state;

    const element = document.getElementById('loader');

    if (!element) {
      return;
    }

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      element.className = refs.length === 0 ? 'hide' : '';
    }, 150);

    return null;
  }

}


// WEBPACK FOOTER //
// ./src/components/LoaderComponent.tsx